(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningItemEditUrlTab", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/learningItems/edit/learningItemType/learningItemEditUrlTabView.html",
            controller: ["$scope", "$uibModal", "_", LearningItemEditUrlTabCtrl],
            controllerAs: "vm"
        };
        function LearningItemEditUrlTabCtrl($scope, $uibModal, _) {
            var vm = this;
            $scope.$parent.vm.learningItemResourceObject.$promise.then(function () {
                vm.learningItem = $scope.$parent.vm.learningItem;
            }).catch(angular.noop);
            vm.getLearningItemUrl = function (id) {
                return _.find(vm.learningItem.learningItemUrlLocalizations, { localizationId: id });
            };
            vm.addLocalization = function (id) {
                var learningItemUrlLocalization = angular.copy(vm.learningItem.learningItemUrlLocalizations[0]);
                learningItemUrlLocalization.id = null;
                learningItemUrlLocalization.localizationId = id;
                learningItemUrlLocalization.url = "";
                learningItemUrlLocalization.embed = "";
                vm.openModal(learningItemUrlLocalization);
            };
            vm.openModal = function (learningItemUrlLocalization) {
                var $modalInstance = $uibModal.open({
                    templateUrl: "/app/learningItems/edit/learningItemType/learningItemEditUrlModalView.html",
                    controller: "LearningItemEditUrlModalCtrl as vm",
                    size: "lg",
                    resolve: {
                        learningItemUrlLocalization: function () {
                            return angular.copy(learningItemUrlLocalization);
                        }
                    }
                });
                $modalInstance.result.then(function (result) {
                    var editRecord = _.find(vm.learningItem.learningItemUrlLocalizations, { localizationId: result.localizationId });
                    if (editRecord)
                        _.extend(editRecord, result);
                    else
                        vm.learningItem.learningItemUrlLocalizations.push(result);
                    reloadLocalizationRepeater();
                }).catch(angular.noop);
            };
            function reloadLocalizationRepeater() {
                vm.learningItem.enabledLocalizations = angular.copy(vm.learningItem.enabledLocalizations);
            }
        }
    });
})();
